import {getLoginInformation} from './loginHelper';
import {
    FETCH_USER_DIRECT_PERKS,
    CREATE_DIRECT_USER_PERK,
    CREATE_DIRECT_USER_PERK_INDIA,
    CONSUME_DIRECT_USER_PERK,
    CLAIM_FREE_PERK
} from '../constants/urls';


export async function fetchUserDirectPerks(
    creatorName:string){
    let loginInformation = getLoginInformation();
    try{
        let resp = await fetch(`${FETCH_USER_DIRECT_PERKS}?creatorName=${creatorName}&userId=${loginInformation.user._id}`, {
	    method: 'GET',
            headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
        });	    
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e);
        return false;
    }
}

export async function createUserDirectPerk(
    perkId:number, creatorName:number){
    let loginInformation = getLoginInformation();
    try {
        let resp = await fetch(CREATE_DIRECT_USER_PERK, {
	    method: 'POST',
            headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
            body: JSON.stringify({
	        perkId: perkId,
                creatorName: creatorName,
	    })
        });	    
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e);
        return false;
    }
}



export async function consumeUserDirectPerk(
    directUserPerkId:number, bidderMessage:any){
    console.log('directUserPerkId', directUserPerkId);
    let loginInformation = getLoginInformation();
    try{
        let resp = await fetch(CONSUME_DIRECT_USER_PERK, {
	    method: 'POST',
            headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
            body:JSON.stringify({
	        directUserPerkId:directUserPerkId,
                bidderMessage:bidderMessage
	    })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e);
        return false;
    }
}

export function convertUserDirectPerksToDict(userDirectPerks:any){
    console.log('userDirectPerks', userDirectPerks);
    let userDirectPerksDict:any = {};
    for(let i=0;i<userDirectPerks.length;i++){
        userDirectPerksDict[userDirectPerks[i].perkId] = (
            userDirectPerks[i]);
    }
    return userDirectPerksDict;
}


export async function buyPowerIndia(perkId:number, creatorName:number){
    let loginInformation = getLoginInformation();
    try {
        let resp = await fetch(CREATE_DIRECT_USER_PERK_INDIA, {
	    method: 'POST',
            headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
            body: JSON.stringify({
	        perkId: perkId,
                creatorName: creatorName,
	    })
        });	    
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e);
        return false;
    }
}



export async function claimFreePerk(claimPerkId:any){
    console.log('claimPerkId', claimPerkId);
    let loginInformation = getLoginInformation();
    try{
        let resp = await fetch(CLAIM_FREE_PERK, {
	    method: 'POST',
            headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
            body:JSON.stringify({
	        claimablePerkId: claimPerkId,
	    })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e);
        return false;
    }
}
